module.exports = __webpack_public_path__ + "img/vue.a2ead10d.svg";